export enum AudienceRuleButtons {
  Delete = 'DELETE',
  Demo = 'DEMO',
  Demographic = 'DEMOGRAPHIC',
  DeviceID = 'DEVINCE_ID',
  Epsilon = 'EPSILON',
  Adsquare = 'ADSQUARE',
  Group = 'GROUP',
  Geofence = 'GEOFENCE',
  Ungroup = 'UNGROUP',
  Predefined = 'PREDEFINED',
  Mastercard = 'MASTERCARD',
  Liveramp = 'LIVERAMP',
}
